import { Box, Typography, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'

import Illustration from '../../assets/illustration_404.png'
import { ReactComponent as AirImpactLogo } from '../../assets/img/logo/airimpact-logo-colorful-with-text.svg'
import { ReactComponent as ArrowBack } from '../../icons/arrow-back.svg'

export default function () {
  const navigate = useNavigate()
  return (
    <Box width="100vw" height="100vh" display="flex" p="40px 60px" bgcolor="white" flexDirection="column">
      <AirImpactLogo />
      <Box m="auto" display="flex" flexDirection="column">
        <img src={Illustration} alt="AirImpact" style={{ width: '680px', height: '450px' }} />
        <Typography variant="h1" align="center" mt={3} color="primary.800" textAlign="center">
          Page not found
        </Typography>
        <Typography variant="body1" align="center" mt={3} color="grey.500" textAlign="center" mb={3.5}>
          Sorry, the page you are looking for doesn't exist or has been moved.
        </Typography>
        <Button
          variant="contained"
          startIcon={<ArrowBack />}
          onClick={() => navigate(-1)}
          sx={{
            width: 'fit-content',
            ml: 'auto',
            mr: 'auto',
          }}
        >
          Go back
        </Button>
      </Box>
    </Box>
  )
}
